import { NgModule } from '@angular/core';
import { TagCategoryListByConceptComponent } from './tag-category-list-by-concept.component';

@NgModule({
  imports: [TagCategoryListByConceptComponent],
  exports: [TagCategoryListByConceptComponent]
})
export class TagCategoryListByConceptModule {}
